import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { modifyDatosCierreDiario } from '../../actions/cierre_diario_actions';
import { openDialog, setSaveState } from '../../actions';
import { loading } from '../../actions/index';

//import { getData, postData, putData } from '../../dataLib';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import FloatNumberFormatText from '../../components/float_number_text_formatter';
import IntNumberFormatText from '../../components/int_number_text_formatter';

//helpers:
import { getData } from '../../dataLib';


const styles = theme => ({

    paperContainer: {
        margin: '20px auto',
    },
    paperItem: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2px 25px',
        boxShadow: 'none',
        border: 0,
    },
    inputImporte: {
        textAlign: 'right',
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 11,
    },
    leftSide: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '50%',
        maxWidth: 190,
    },
    label: {
        textAlign: 'left',
        marginRight: 5,
        fontSize: 12,
    },
    input: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '50%',
        alignItems: 'center',
    },
    button: {
        padding: '0 5px',
        marginLeft: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 0,
        fontSize: 10,
        // minWidth: 40,
        width: '46%',
        minWidth: 45,
        height: 35,
        '&:hover': {
            backgroundColor: '#cc8ebf'
        },
        boxShadow: '1px 1px 1px darkgrey',
        overflow: 'hidden'
    },
    buttonContent: {
        display: 'flex',
        flexDirection: 'column',
    },
});

class CierreDiarioItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            prevImporte: this.props.producto.importe,
            importe: this.props.producto.importe
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (prevState.prevImporte !== nextProps.producto.importe) {
            return {
                prevImporte: nextProps.producto.importe,
                importe: nextProps.producto.importe
            };
        }
        else {
            return null;
        }

    }

    handleImporteChange = (event) => {
        if (event.target.value !== '') {
            this.props.setSaveState(true);
            this.setState({ ...this.state, importe: event.target.value });
        }
        else this.setState({ ...this.state, importe: 0 });
    }

    onValueChange = (value) => {
        this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: this.state.importe });
        if ( this.props.producto.isMovCaja === 0 &&  this.props.producto.legKind === -2 )
            this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: this.state.importe });

    }

    actualizaRedSys = () => {
        this.props.loading(false);
        // obtiene el nuevo valor de RedSys para esta fecha y centro 
        this.props.setSaveState(true);

        let urlVisas = 'cierrediario/visasredsys?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;
        getData(
            urlVisas,
            response => {
                var visas = response.data;
                this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: visas });
                this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: visas });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'error obteniendo visas de REDSYS',
                    },
                    'error-centro-dia-visas-redsys',
                    false,
                    'sm',
                );
            },
            this.props.user,
        );

    }

    generateButton1 = () => {
        const { classes } = this.props;
        switch (this.props.producto.iKind) {
            case 0:
                if ( this.props.producto.legKind === -2)
                return (
                    <Button variant="contained" size="small" className={classes.button} fullWidth 
                            onClick={ () => { this.props.loading(true); this.actualizaRedSys(); }
                                }>
                        <div className={classes.buttonContent}>Actualiza</div>
                    </Button>
                );
            else
                    return (<div></div>);

            case 1:
                if ( this.props.producto.legKind !== -2)
                    return (
                        <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreDiarioMKTGrid', {
                            producto: this.props.producto
                        }, uuidv4(), true, "md")}>
                            <div className={classes.buttonContent}> {'MKT:  '} <FloatNumberFormatText value={this.props.producto.button1} /></div>
                        </Button>
                    );
                else
                    return (<div></div>);
            case 3:
                return (
                    <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreDiarioArcadeGrid', {
                        producto: this.props.producto
                    }, uuidv4(), true, "sm")}>
                        {"Contadores ..."}
                    </Button>
                );
            case 4:
                return (
                    <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreDiarioGastosGrid', {
                        producto: this.props.producto
                    }, uuidv4(), true, "md")}>
                        {"Detalle Gastos ..."}
                    </Button>
                );
            case -5:
                return (
                    <Button variant="contained" size="small" autoFocus={this.props.producto.button1 === 0} className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreDiarioPartidasTipoGrid', {
                        producto: this.props.producto
                    }, uuidv4(), true, "sm")}>
                        <div className={classes.buttonContent}> {'Part*Tipo: '} <IntNumberFormatText value={this.props.producto.button1} /></div>
                    </Button>
                );
            case 6:
                return (
                    <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('Arqueo', {
                        producto: this.props.producto,
                        disabled: this.props.isDiaCerrado

                    }, uuidv4(), true, "xs")}>
                        {'Arqueo...'}
                    </Button>
                );
            case -7:
                return (
                    <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreDiarioPorHoras', {
                        producto: this.props.producto,
                        productoRelacionado: this.props.productoRelacionado,
                        importSigfrid: this.importSigfrid,
                        dataType: 'float'
                    }, uuidv4(), true, 'xs')}>
                        <div className={classes.buttonContent}> {'Vtas*Hora: '} <FloatNumberFormatText value={this.props.producto.button1} /></div>
                    </Button>
                );
            default:
                return (<div></div>);
        }
    }

    generateButton2 = () => {
        const { classes } = this.props;
        switch (this.props.producto.iKind) {
            case -5:
                return (
                    <Button variant="contained" size="small" className={classes.button} autoFocus={this.props.producto.button1 !== 0 && this.props.producto.button2 === 0} fullWidth onClick={() => this.props.openDialog('CierreDiarioPorHoras', {
                        producto: this.props.producto,
                        dataType: 'int'
                    }, uuidv4(), true, 'xs')}>
                        <div className={classes.buttonContent}> {'Part*Hora: '} <IntNumberFormatText value={this.props.producto.button2} /></div>
                    </Button>
                );
            case -7:
                /* if (this.props.centroDiaSelected.centro.sigfrid !== -1) {
                    return (
                        <Button variant="contained" size="small" className={classes.button} disabled={this.props.isDiaCerrado} fullWidth onClick={() => { this.importSigfrid(this.sigfridHandler) }}>
                            <div className={classes.buttonContent}> {'Importar datos Sigfrid'} </div>
                        </Button>
                    );
                } */
                break;
            default:
                return (<div></div>)

        }
    }

    /*importSigfrid = (thenHandler) => {

        const getURL = 'sigfrid?centro_id=' + this.props.centroDiaSelected.centro.sigfrid + '&date=' + this.props.centroDiaSelected.dia;

        getData(getURL,
            (response) => {

                let totales = [];

                let normal = 0.0;
                let packs = 0.0;

                for (const key in response.data.datos) {

                    if (key !== "local" && key !== "fecha" && key !== "cabeceras" && key !== "totales") {

                        const linea = response.data.datos[key];

                        //if (linea[20].value21 === null || linea[20].value21 === '') {

                        if (linea[10].value11 !== '002' && linea[10].value11 !== '001') {

                            const hora = parseInt(linea[12].value13.slice(0, 2));
                            const importe = parseFloat(linea[8].value9.replace('.', '').replace(',', '.'));
                            const tipo = linea[13].value14;

                            if (totales[hora] !== undefined) totales[hora] += importe;
                            else totales[hora] = importe;

                            if (tipo === "MESA") packs += importe;
                            else normal += importe;

                        }
                    }
                }

                var newDesglose = {};

                let antes12 = 0.0;
                for (let i = 5; i <= 12; i++) {
                    if (totales[i] !== undefined) antes12 += totales[i];
                }

                newDesglose.hora01 = antes12;
                newDesglose.hora02 = totales[13] ? totales[13] : 0.0;
                newDesglose.hora03 = totales[14] ? totales[14] : 0.0;
                newDesglose.hora04 = totales[15] ? totales[15] : 0.0;
                newDesglose.hora05 = totales[16] ? totales[16] : 0.0;
                newDesglose.hora06 = totales[17] ? totales[17] : 0.0;
                newDesglose.hora07 = totales[18] ? totales[18] : 0.0;
                newDesglose.hora08 = totales[19] ? totales[19] : 0.0;
                newDesglose.hora09 = totales[20] ? totales[20] : 0.0;
                newDesglose.hora10 = totales[21] ? totales[21] : 0.0;
                newDesglose.hora11 = totales[22] ? totales[22] : 0.0;
                newDesglose.hora12 = totales[23] ? totales[23] : 0.0;
                newDesglose.hora13 = totales[0] ? totales[0] : 0.0;
                newDesglose.hora14 = totales[1] ? totales[1] : 0.0;
                newDesglose.hora15 = totales[2] ? totales[2] : 0.0;
                newDesglose.hora16 = totales[3] ? totales[3] : 0.0;
                newDesglose.hora17 = totales[4] ? totales[4] : 0.0;
                newDesglose.hora18 = 0.0;
                newDesglose.hora19 = 0.0;
                newDesglose.hora20 = 0.0;
                newDesglose.hora21 = 0.0;
                newDesglose.hora22 = 0.0;
                newDesglose.hora23 = 0.0;
                newDesglose.hora24 = 0.0;

                thenHandler({ desglose: newDesglose, normal: normal, packs: packs });

            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching sigfrid - ' + error
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    }

    sigfridHandler = (sigfrid) => {
        
        const desgloseURL = 'dadesglosehoras/cierrediario?zona_id=' + this.props.producto.zonaId + '&date=' + this.props.centroDiaSelected.dia;

        getData(desgloseURL,
            (response) => {
                if (response.data.id === -1) {
                    this.newDesglose(sigfrid, response.data.articuloId);
                } //nuevo desglose
                else {
                    this.updateDesglose(sigfrid, response.data.id, response.data.articuloId);
                } //actualizar desglose
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching desglose horas - ' + error
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );


    }

    updateDesglose = (response, desgloseId, articuloId) => {

        const art2 = this.props.productoRelacionado ? this.props.productoRelacionado.articuloId : '0';

        let desgloseURL = 'dadesglosehoras/' + desgloseId;
        desgloseURL += '?art1=' + this.props.producto.articuloId + '&art2=' + art2 + '&normal=' + response.normal + '&packs=' + response.packs;

        putData(desgloseURL,
            () => {
                const message = this.props.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm');
                this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: response.normal + response.packs, importe: response.normal });
                this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: response.packs });

            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando ventas por hora'
                }, uuidv4(), false, 'sm');
            },
            { ...response.desglose, id: desgloseId, articuloId: articuloId, fecha: this.props.centroDiaSelected.dia },
            this.props.user
        );

    }

    newDesglose = (response, articuloId) => {

        const art2 = this.props.productoRelacionado ? this.props.productoRelacionado.articuloId : '0';

        let desgloseURL = 'dadesglosehoras';
        desgloseURL += '?art1=' + this.props.producto.articuloId + '&art2=' + art2 + '&normal=' + response.normal + '&packs=' + response.packs;

        postData(desgloseURL,
            () => {
                const message = this.props.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm');

                this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: response.normal + response.packs, importe: response.normal });
                this.props.modifyDatosCierreDiario({ ...this.props.productoRelacionado, importe: response.packs });

            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating desglose horas 2'
                }, uuidv4(), false, 'sm');
            },
            { ...response.desglose, id: -1, articuloId: articuloId, fecha: this.props.centroDiaSelected.dia },
            this.props.user
        );

    }*/

    render() {
        const { classes } = this.props;
        
        return (
            <Paper className={classes.paperItem} >

                <div className={classes.leftSide}>
                    <Typography variant="subtitle2" className={classes.label}>
                        {this.props.producto.producto}
                    </Typography>
                    <TextField
                        className={classes.input}
                        id={'importe_' + this.props.producto.articuloId}
                        placeholder='Importe'
                        autoFocus={this.props.producto.button1 !== 0 && this.props.producto.button2 !== 0}
                        onFocus={e => {
                            e.target.setSelectionRange(0, 1000);
                        }}
                        value={this.state.importe}
                        onChange={(event) => this.handleImporteChange(event)}
                        onBlur={(event) => this.onValueChange(event.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') { e.preventDefault(); this.onValueChange(e.target.value) };
                        }}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                        disabled={
                            this.props.producto.iKind === 4 || // Gastos
                            this.props.producto.iKind === 6 || // Arqueo
                            this.props.producto.iKind === 3 || // Maq. Cambios
                            this.props.producto.iKind === 1 || // MKT y Redsys VISA
                            this.props.producto.iKind === 100 ||
                            this.props.producto.iKind === -5 ||  // bolera
                            this.props.producto.articuloId === 2974 ||
                            this.props.producto.articuloId === 3295 ||
                            this.props.producto.articuloId === 2971 ||
                            // this.props.producto.iKind === 1 ||
                            // this.props.producto.iKind === 3 ||
                            (this.props.producto.isMovCaja === 0 && this.props.producto.legKind === -2) || // REDSYS ingresos
                            (this.props.centroDiaSelected.centro.sigfrid !== -1 && (this.props.producto.iKind === -7 || this.props.producto.iKind === -8)) ||
                            this.props.isDiaCerrado
                        }
                    />
                </div>
                <div className={classes.buttonContainer}>
                    {this.generateButton1()}
                    {this.generateButton2()}
                </div>

            </Paper>
        );
    };
};


CierreDiarioItem.propTypes = {
    //state
    isDiaCerrado: PropTypes.bool.isRequired,
    //dispatch
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    //parameters
    producto: PropTypes.object.isRequired,
    productoRelacionado: PropTypes.object

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        //datosCierreDiario: state.datosCierreDiario.datos
        centroDiaSelected: state.centroDiaSelected,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyDatosCierreDiario,
        openDialog,
        setSaveState,
        loading,
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioItem));
